"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomConfigOutSerializer = void 0;
exports.ZoomConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=zoomConfigOut.js.map